import { Component, OnInit, ViewChild } from "@angular/core";
import { BaseSection } from "../../extends/base-section";
import { ResponseUiService } from "../../utils/response-ui.service";
import { FormService } from "../../services/form.service";
import { IFormSection } from '../../interfaces/form-section';
import { MainStore } from "../../store/main-store";
import { SInputComponent } from "../../shared/components/s-input/s-input.component";
import { SAutocompleteComponent, AutocompleteModel } from "../../shared/components/s-autocomplete/s-autocomplete.component";
import { InputModel, InputEnum } from "../../shared/extends-components/binput-component";
import { ButtonModel } from "../../shared/extends-components/bbutton-component";
import { SAlertComponent } from "../../shared/components/s-alert/s-alert.component";
import { MesaggeText } from "../../shared/texts/mesagge-text";
import { IResponseService } from "../../interfaces/response-service";
import { ResponseEnum } from "../../enums/ResponseEnum.enum";
import { environment } from "../../../environments/environment";
import { Utils } from "../../utils/utils";
import { CertificadoStore } from "../../store/certificado-donacion-store";
import { AsociadoModel } from "../../shared/models/datosAsociado";
import { ParametrosDTO } from "../../shared/models/ParametrosDTO";
import { SComboboxComponent } from "../../shared/components/s-combobox/s-combobox.component";
import { CuentaMatriculaModel } from "../../shared/models/cuenta-matricula-model";
@Component({
  selector: "app-inicio",
  templateUrl: "./inicio.component.html",
  styleUrls: ["./inicio.component.scss"]
  
})
export class InicioComponent extends BaseSection
implements OnInit, IFormSection {
  direccionIp;
  objAsociado: AsociadoModel;
  tipoCuentaList: any[];
  NumeroDeCedulaAsesor: any[];
  bancoList: any[];
  mensajeConfirmacion: string;
  cuentaMatricula: CuentaMatriculaModel;
  mostrar:boolean=false;
  
  

 

  
  @ViewChild("InputNames")
  InputNames: SInputComponent;
  @ViewChild("InputNumberId")
  InputNumberId: SInputComponent;
  @ViewChild("InputEmail")
  InputEmail: SInputComponent;
  @ViewChild("InputCuenta")
  InputCuenta: SInputComponent;


  TitlePage: "Matricula tu Cuenta";



  FieldNames: InputModel = {
    Label: "Nombre completo",
    IsRequired: true,
    Type: InputEnum.Text,
    LenMax: 51,
    Disable: true
  };

  FieldNumberId: InputModel = {
    Label: "Número de identificación",
    IsRequired: true,
    Type: InputEnum.Text,
    LenMax: 20,
    Disable: true
  };

  FieldEmail: InputModel = {
    Label: "Correo electrónico",
    IsRequired: true,
    Type: InputEnum.Text,
    LenMax: 100,
    Disable: true,
    value:"1"
  };

  FieldCuenta: InputModel = {
    Label: "Número Cuenta",
    IsRequired: true,
    Type: InputEnum.Text,
    LenMax: 30,
    Tooltip: {
      Label: MesaggeText.TOOLTIP_NUMERO_CUENTA
    }
  };

  btnSave: ButtonModel = {
    Label: "Guardar",
    Hidden: true,
    IconCss: "save"
  };

  constructor(
    public responseUI: ResponseUiService,
    public formServ: FormService,
    
   
    

  ) {
    super();
  }


  ngOnInit() {
    this.NumeroDeCedulaAsesor=[];
    this.tipoCuentaList = [];
    this.bancoList = [];
    this.mensajeConfirmacion = "";
    this.cuentaMatricula = new CuentaMatriculaModel();
    this.getIP();
    this.InputNumberId.SetDisable(true);
    this.InputNames.SetDisable(true);
    this.InputEmail.SetDisable(true);
    this.objAsociado = MainStore.db.GetUser();
    
    



    setTimeout(() => {
      this.cargaParametros();
      let nombre1 = this.objAsociado.nombre1 != undefined ? this.objAsociado.nombre1.trim() : '';
      let nombre2 = this.objAsociado.nombre2 != undefined ? this.objAsociado.nombre2.trim() : '';
      let apellido1 = this.objAsociado.primerApellido != undefined ? this.objAsociado.primerApellido.trim() : '';
      let apellido2 = this.objAsociado.segundoApellido != undefined ? this.objAsociado.segundoApellido.trim() : '';
      this.InputNames.SetData(nombre1 + ' ' + nombre2 + ' ' + apellido1 + ' ' + apellido2);
      this.InputNumberId.SetData(this.objAsociado.numeroDocumento);
      this.InputEmail.SetData(this.objAsociado.email);
    }, 2000);
  }

  

  cargaParametros() {
    this.formServ.getParametros().
      then((response) => {
        response.data.forEach(pos => {
          if (pos.nombreAtributo == "TIPO_CUENTA_LIST") {
            this.tipoCuentaList.push(pos);
          }

          if (pos.nombreAtributo == "BANCO_LIST") {
            this.bancoList.push(pos);
          }
          if (pos.nombreAtributo == "NUMERO_DE__ASESOR") {
            this.NumeroDeCedulaAsesor.push(pos);
          }

          if (pos.nombreAtributo == "MENSAJE_CONFIRMACION_PAGINA_CUENTA_MATRICULA") {
            this.mensajeConfirmacion = pos.valor;
          }
        });
      }, (fail) => {
        SAlertComponent.AlertError('Error en el servicio ' + fail);
      })
  }
  /**
    * @author Jose Wilson Mulato
    * @description obtiene Direccion Ip
    */
  getIP() {
    this.formServ.getIPAddress().subscribe((res: any) => {
      this.direccionIp = res.ip;
    });
  }
  Mostrar(){

    if( this.mostrar){
      this.mostrar = false; }  
     else{
       this.mostrar = true;}
      
      }

      //variables de validacion
      validador:string="0"
      primero = this.validador;
      
    
      
  ngAfterContentInit() {
  }
  /**
     * @author Jose Wilson Mulato
     * @description Mandar a confirmar la donacion
     */
  clickConfirm() {
    /*if (this.objAsociado.estado != 10 && this.objAsociado.estado != 11) {
      return SAlertComponent.AlertWarning(MesaggeText.VALID_STATE_ASOC);
    }*/
    if(this.InputCuenta.GetData() != null && this.InputCuenta.GetData() != undefined) {
      this.InputCuenta.SetData(this.InputCuenta.GetData().trim());
    }
    
    let isValid = true;
    let message = '<div style="text-align: left;">';
    if (this.InputCuenta.GetData() == null)  {
      let campo = "N&uacute;mero de cuenta";
      campo = campo.italics();
      campo = campo.bold();
      isValid = false;
      message+=("El " + campo + " es obligatorio <br>");
    } else if (!this.isNumber(this.InputCuenta.GetData()))  {
      let campo = "N&uacute;mero de cuenta";
      campo = campo.italics();
      campo = campo.bold();
      isValid = false;
      message+=("El " + campo + " debe ser un valor num&eacute;rico sin espacios, puntos o guiones. Ejemplo: 0123456789 <br>");
    }else if (this.InputCuenta.GetData().length < 9)  {
      let campo = "N&uacute;mero de cuenta";
      campo = campo.italics();
      campo = campo.bold();
      isValid = false;
      message+=("El " + campo + " debe ser igual o mayor a 9 dig\u00EDtos <br>");
    }

    if (this.cuentaMatricula.codigoBanco.length <= 0) {
      let campo = "Banco";
      campo = campo.italics();
      campo = campo.bold();
      isValid = false;
      message+=("El " + campo + " es obligatorio <br>");
    }//validacion de numero cedula asesor 
    if (this.cuentaMatricula.numeroDeCedulaAsesor !== this.validador) {
   
      let campo = " Cedula del Asesor";
      campo = campo.italics();
      campo = campo.bold();
      isValid = false;
      message+=("Los campos " + campo + " y Confirmación "+ campo +" no son iguales, por favor verificar <br>");
    }if( this.cuentaMatricula.numeroDeCedulaAsesor ===null || this.validador===null ||this.cuentaMatricula.numeroDeCedulaAsesor == this.primero && this.mostrar ){
      let campo = " Cedula del Asesor";
      campo = campo.italics();
      campo = campo.bold();
      isValid = false;
      message+=("Por favor diligenciar los campos de "+ campo);
    }
      
    if (this.cuentaMatricula.tipoCuenta.length <= 0) {
      let campo = "Tipo de cuenta";
      campo = campo.italics();
      campo = campo.bold();
      isValid = true;
      message+=("La " + campo + " es obligatorio <br>");
    }

    if(!isValid) {
      SAlertComponent.showWarning(message);
      return;
    }

      SAlertComponent.ConfirmHTML(
        "Asociado(a): ¿Confirma que desea matricular la Cuenta Bancaria <b>" + this.InputCuenta.GetData() + ' - ' + this.getBanco(this.cuentaMatricula.codigoBanco) + "</b> para permitir d\u00E9bito autom\u00E1tico de su Estado de Cuenta?",
      ).then(isaceppt => {        
        if (isaceppt) {          
          this.Save();
        } else {          
          return;
        }
      });
    


  }

  getBanco(codigo) {
    
    for(let i = 0; i < this.bancoList.length;i ++) {
      let banco = this.bancoList[i];

      if(banco.valor == codigo) {
        return banco.descripcion;
      }
    }

    return '';
  }

  isNumber(value: string): boolean {
   
		return (/^([0-9])*$/.test(value));
  }
  
  OnExitSeccion() {
    SAlertComponent.Confirm2(
      MesaggeText.TEXT_EXIT_APP,
      false,
      MesaggeText.TITLE_ALERT
    ).then(response => {
      if (response) {
       
        window.location.href = MainStore.ORIGIN == 1 ? 
                                      window.location.origin + environment.index  + '/#/login' :
                                      '';
      }
    });
  }
  /**
   * @author Jose Wilson Mulato
   * @description Mandar a guardar el dato al servicio
   */

  
  async Save(): Promise<any> {
    return new Promise((success, fail) => {
      SAlertComponent.ShowSpinner();
      MainStore.db
        .MatricularCuenta({
          identificacionAsociado: this.InputNumberId.GetData(),
          nombreAsociado: this.InputNames.GetData(),
          ip: this.direccionIp == null && this.direccionIp == undefined ? 'NOIP' : this.direccionIp,
          estadoAsociado: this.objAsociado.estado,
          emailAsociado: this.objAsociado.email,
          estadoReportOperacion: 'N',
          tipoCuenta: this.cuentaMatricula.tipoCuenta,
          codigoBanco: this.cuentaMatricula.codigoBanco,
          numeroCuenta: this.InputCuenta.GetData(),
          tipoOperacion: 2,
          numeroDeCedulaAsesor:this.cuentaMatricula.numeroDeCedulaAsesor
        })
        .then((response: IResponseService) => {
          this.responseUI.CheckResponseForError(response).then(result => {
            SAlertComponent.CloseSpinner();
            if (response.message != null && response.status == ResponseEnum.OK) {
              this.showMessage('<div style="text-align: justify;">Su matr&iacute;cula para la Cuenta Bancaria <b>' + this.InputCuenta.GetData() + '-' + 
              this.getBanco(this.cuentaMatricula.codigoBanco) + '</b> fue exitosa <br>' + '<b>¡Gracias por su permanencia! Con su aporte mantenemos viva la fuerza de la cooperaci&oacute;n y el progreso de todos. </b>' +
              '<br>Gracias a la activaci&oacute;n de su d&eacute;bito autom&aacute;tico y al estar al d&iacute;a con su cooperativa, podr&aacute; participar por premios<br>' +
              '</div><dvi style=>*Aplican términos y condiciones <br>' +
              '<a href="https://www.coomeva.com.co/publicaciones/155258/estar-al-dia-activando-tu-debito-automatico-es-una-eleccion-que-te-premia/" target="_blank_">M&aacute;s informaci&oacute;n </div>"'
               );
            } else {
              this.showMessage(response.messageError);
            }
            
          });
        })
        .catch(error => {
          SAlertComponent.CloseSpinner();
          this.responseUI.CheckResponseForError(error);
          success(false);
        });
    });
  }


  showMessage(msj: string) {
    SAlertComponent.CloseSpinner();
    SAlertComponent.showExito(msj)
    .then(isaceppt => {
      SAlertComponent.CloseSpinner();
      setTimeout(() => {
        window.location.href = MainStore.ORIGIN == 1 ? 
          window.location.origin + environment.index + '/#/login':
          '';
      }, 1000);
    });
  }

  /**
   * @author Jose Wilson Mulato
   * @description Valida los campos este correctos
   */
  async Valid(): Promise<any> {
    let isValid = this.ValidFields([
      this.InputNumberId,
      this.InputNames,
      this.InputCuenta
    ]);
    return isValid;
  }
  

 
}
      


// WEBPACK FOOTER //
// ./src/app/pages/home/inicio.component.ts